export default __webpack_public_path__ + "static/media/OO_logo_wo_safespace_Secondary - Mark - Color.c7115ef7.svg";